import { MouseEvent } from "react";
import Button from "../../../../Component/Elements/Button/Normal/Button";
import Text from "../../../../Component/Elements/Text/Text";

const AddAddressBtn = (
    {
        class_name_list,
        addEmptyAddressHandler,
        is_visible,
    }:{
        class_name_list?: string[];
        addEmptyAddressHandler: (event: MouseEvent<HTMLButtonElement>) => void;
        is_visible: boolean;
    }
) => {
    if(is_visible){
        return(
            <Button
                class_name_list={class_name_list}
                size={"size3"}
                preset={"background_white"}
                onClick={addEmptyAddressHandler}
            >
                <Text
                    size={"size2"}
                    color={"gray3"}
                >
                    주소 추가 입력 +
                </Text>
            </Button>
        )
    }else{
        return null;
    }
}

export default AddAddressBtn;